import { IColumn } from "@fluentui/react";
import React, { ReactElement } from "react";
import { ListTableColumn, createListTableColumns, ensure, Text, Stack, Link } from "sprint-common-web";

import { renderContentSubtype } from "../../../common/utils/renderContentSubtype";
import { LookupHistoryItem } from "./LookupHistoryList";

interface CreateLookupHistoryListColumnsProps {
    onItemClicked: (item: LookupHistoryItem) => void;
}

export const createLookupHistoryListColumns = (
    props: CreateLookupHistoryListColumnsProps
): ListTableColumn<LookupHistoryItem>[] => {
    return createListTableColumns<LookupHistoryItem>([
        {
            type: "interactive",
            key: "title",
            name: "Title",
            onItemInvoked: props.onItemClicked,
            onRender: renderObjectTitle,
            minWidth: 150,
            maxWidth: 200
        },
        {
            type: "basic",
            key: "type",
            name: "Content type",
            minWidth: 100,
            maxWidth: 100,
            onRender: renderContentSubtype
        },
        {
            type: "basic",
            key: "versions",
            name: "Versions",
            minWidth: 150,
            maxWidth: 200,
            onRender: renderVersions
        }
    ]);
};

const renderObjectTitle = (
    item?: LookupHistoryItem,
    _index?: number,
    column?: ListTableColumn<unknown> & IColumn
): ReactElement | null => {
    ensure(item);
    ensure(column);
    ensure(column.currentWidth);

    const onClick = () => column.onItemInvoked && column.onItemInvoked(item);

    return (
        <Link
            onClick={onClick}
            styles={{
                root: { width: "100%" }
            }}
            testAttributes={{
                "data-testid": "item-title"
            }}
        >
            <Text value={item.title} variant="smallPlus" />
        </Link>
    );
};

const renderVersions = (item?: LookupHistoryItem): ReactElement | null => {
    ensure(item);

    return (
        <Stack tokens={{ childrenGap: 5 }} data-testid="item-versions">
            {item.versions.map((v) => (
                <Text key={v.id} variant="smallPlus" value={v.name} />
            ))}
        </Stack>
    );
};
